function permissionSet(permissions) {
  if (permissions instanceof Set) {
    return permissions;
  }
  return new Set(Array.isArray(permissions) ? permissions : []);
}

export function hasPermission(permissions, code) {
  return Boolean(code) && permissionSet(permissions).has(code);
}

export function hasOptionalPermission(permissions, code) {
  return !code || hasPermission(permissions, code);
}

export function hasEveryPermission(permissions, requiredCodes) {
  const available = permissionSet(permissions);
  return (requiredCodes || []).every(
    (code) => Boolean(code) && available.has(code)
  );
}
